import * as S from './styles';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router';
import { formatToBRL } from 'base/src/utils/mathUtil';
import { formatDate } from 'base/src/utils/stringUtil';
import { Tag } from 'base/src/components/Tag';
import { ExtratoResponse } from '../../../../types/extrato/extratoResponse';

interface ExtratoListProps {
  extrato: ExtratoResponse[] | undefined
  hideValues: boolean
}

function ExtratoList ({ extrato, hideValues = false }: ExtratoListProps) {
  const navigate = useNavigate();

  function handleClick(item : ExtratoResponse){
    return () => {
      if (item.Tipo !== 'Saque') return;
      navigate(`/pagamento/${item.Id}`);
    }
  }

  return (
    <S.Container>
      <S.HeaderContainer>
        <S.IdHeader>ID</S.IdHeader>
        <S.DateHeader>Data</S.DateHeader>
        <S.DescricaoHeader>Descrição</S.DescricaoHeader>
        <S.TipoHeader>Tipo</S.TipoHeader>
        <S.StatusHeader>Status</S.StatusHeader>
        <S.ValorHeader>Valor</S.ValorHeader>
        <S.ValorHeader>Novo Balanço</S.ValorHeader>
      </S.HeaderContainer>

      {extrato?.slice().map((item, index) => (
        <S.ItemContainer
          key={item.DataOperacao || index}
          onClick={handleClick(item)}
        >
          <S.Id>#{item.Id}</S.Id>
          <S.Date>{formatDate(item.DataOperacao)}</S.Date>
          <S.Descricao>{item.Descricao}</S.Descricao>
          <S.Tipo>{item.Tipo}</S.Tipo>
          <S.Status>
            {
              item.Status === 'Pendente' ?
                <Tag full variant='warning'>
                  {item.Status}
                </Tag> :
                item.Status === 'Cancelado' ?
                  <Tag full variant='danger'>
                    {item.Status}
                  </Tag>
                    :
                  <Tag full variant='positive'>
                    {item.Status}
                  </Tag>
            }
          </S.Status>
          <S.Valor>
            {hideValues ? "R$ *****,**" : formatToBRL(item.ValorAdicionado || 0)}  &nbsp;&nbsp;
            {
              item.ValorAdicionado > 0 ?
                  <Icon icon="mdi:arrow-up" color='green'/>
                  :
                  <Icon icon="mdi:arrow-down" color='red'/>
            }
            </S.Valor>
          {
            item.NovoBalanco == 0 ? (
              <S.Valor>Pendente</S.Valor>
            ) : (
              <S.NovoBalanco tipo={item.Tipo}>{hideValues ? "R$ *****,**" : formatToBRL(item.NovoBalanco)}</S.NovoBalanco>
            )
          }
        </S.ItemContainer>
      ))}
    </S.Container>

  );
}

export default ExtratoList;